<template>
  <v-container
    fluid
    class="px-8"
    :style="{
      pointerEvents: isReadOnly ? 'none' : 'auto',
    }"
  >
    <v-form ref="form" v-model="valid">
      <v-card
        v-if="allForm.partner_type !== 'Sponsor'"
        outlined
        class="px-6 py-2"
        elevation="1"
      >
        <v-row>
          <v-col cols="3" md="3" class="pt-4 pl-4">
            <label class="form-label-status"
              >Occupation <span class="error--text">* </span></label
            >
          </v-col>
          <v-col cols="9" md="9" class="input-col">
            <v-radio-group
              v-model="applicantForm.occupation"
              row
              dense
              :rules="[rules.required]"
              class="pt-0"
              hide-details="auto"
            >
              <v-radio label="Student" value="Student"></v-radio>
              <v-radio label="Unemployed" value="Unemployed"></v-radio>
              <v-radio label="Employed" value="Employed"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="applicantForm.occupation === 'Employed'"
            class="pl-4"
          >
            <label class="form-label-status"
              >Company Name <span class="error--text">* </span></label
            >
          </v-col>
          <v-col
            cols="12"
            md="9"
            v-if="applicantForm.occupation === 'Employed'"
          >
            <v-text-field
              v-model="applicantForm.company_name"
              outlined
              dense
              :rules="[rules.required]"
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>
      <v-card v-else outlined class="px-6 py-2" elevation="1">
        <v-row>
          <v-col cols="3" md="3" class="pt-4 pl-4">
            <label class="form-label-status"
              >Employee ID <span class="error--text">* </span></label
            >
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="applicantForm.employee_id"
              outlined
              dense
              :rules="[rules.required]"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="3" md="3" class="pt-4 pl-4">
            <label class="form-label-status"
              >Employee Email ID <span class="error--text">* </span></label
            >
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="applicantForm.employee_email_id"
              outlined
              dense
              :rules="[rules.required, rules.email]"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <label class="form-label-status"
              >ID Card Upload <span class="error--text">*</span></label
            >
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-if="applicantForm.is_id_card_attached"
              v-model="applicantForm.id_card.file_name"
              class=""
              hint="ID Card Attached"
              persistent-hint
              dense
              readonly
              outlined
              @click="$refs.idCardInput.click()"
              prepend-inner-icon="mdi-file-upload"
            ></v-text-field>
            <v-file-input
              v-else
              v-model="applicantForm.idCard"
              outlined
              dense
              accept="application/pdf, image/png, image/jpeg, image/jpg"
              hide-details="auto"
              :rules="[rules.required]"
              prepend-inner-icon="mdi-file-upload"
              prepend-icon=""
            ></v-file-input>
            <input
              type="file"
              style="display: none"
              ref="idCardInput"
              @change="
                onEmployeeFileChanged($event, 'idCard', 'is_id_card_attached')
              "
              accept="application/pdf, image/png, image/jpeg, image/jpg"
            />
          </v-col>
          <v-col cols="12" md="3">
            <label class="form-label-status" style="white-space: nowrap"
              >Full Time Employment Letter Upload
              <span class="error--text">*</span>
            </label>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-if="applicantForm.is_employment_letter_attached"
              v-model="applicantForm.employment_letter.file_name"
              class=""
              hint="Full Time Employment Letter Attached"
              persistent-hint
              dense
              readonly
              outlined
              @click="$refs.employmentLetterInput.click()"
              prepend-inner-icon="mdi-file-upload"
            ></v-text-field>
            <v-file-input
              v-else
              v-model="applicantForm.employmentLetter"
              outlined
              dense
              accept="application/pdf, image/png, image/jpeg, image/jpg"
              hide-details="auto"
              :rules="[rules.required]"
              prepend-inner-icon="mdi-file-upload"
              prepend-icon=""
            ></v-file-input>
            <input
              type="file"
              style="display: none"
              ref="employmentLetterInput"
              @change="
                onEmployeeFileChanged(
                  $event,
                  'employmentLetter',
                  'is_employment_letter_attached',
                )
              "
              accept="application/pdf, image/png, image/jpeg, image/jpg"
            />
          </v-col>
        </v-row>
      </v-card>
      <v-expansion-panels v-model="panels" multiple class="mt-3">
        <v-expansion-panel
          v-for="(edu, index) in educationForm"
          :key="index"
          :disabled="index > 0 && !isPreviousLevelComplete(index)"
        >
          <v-expansion-panel-header class="text-h6">
            {{ edu.qualification_name }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="form-row mt-3">
              <v-col cols="12" md="3" class="text-left pt-2 pb-0 label-col">
                <label class="form-label"
                  >Name of Institution <span class="error--text">*</span></label
                >
              </v-col>
              <v-col cols="12" md="9" class="input-col">
                <v-text-field
                  v-model="edu.name_of_institution"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="form-row">
              <v-col cols="12" md="3" class="text-left pt-2 label-col">
                <label class="form-label"
                  >Upload Marksheet <span class="error--text">*</span></label
                >
              </v-col>
              <v-col
                cols="12"
                :md="
                  index === educationForm.length - 1 &&
                  edu.qualification_order > 2
                    ? 7
                    : 9
                "
                class="input-col"
              >
                <v-text-field
                  v-if="edu.is_attached"
                  v-model="edu.upload_image.file_name"
                  class=""
                  hint="Document attached"
                  persistent-hint
                  dense
                  readonly
                  outlined
                  @click="$refs.fileInput[index].click()"
                  prepend-inner-icon="mdi-file-upload"
                ></v-text-field>
                <v-file-input
                  v-else
                  v-model="edu.upload_image"
                  outlined
                  dense
                  accept="application/pdf, image/png, image/jpeg, image/jpg"
                  hide-details="auto"
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-file-upload"
                  prepend-icon=""
                ></v-file-input>
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  @change="onFileChanged($event, index)"
                  accept="application/pdf, image/png, image/jpeg, image/jpg"
                />
              </v-col>
              <v-col
                v-if="
                  index === educationForm.length - 1 &&
                  edu.qualification_order > 2
                "
                cols="12"
                :md="
                  index === educationForm.length - 1 &&
                  edu.qualification_order > 2
                    ? 2
                    : 0
                "
                class="input-col"
              >
                <v-checkbox
                  v-model="applicantForm.completion_status"
                  class="mt-1"
                  density="compact"
                  true-value="Awaiting Result"
                  false-value="Completed"
                  hide-details="auto"
                >
                  <template v-slot:label>
                    <span>Awaiting Result</span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>

            <v-row class="form-row" v-if="edu.qualification_order > 2">
              <v-col cols="12" md="3" class="text-left pt-2 label-col">
                <label class="form-label">
                  Upload Final/Provisional Certificate
                  <span
                    v-if="
                      index !== educationForm.length - 1 ||
                      (edu.qualification_order > 2 &&
                        applicantForm.completion_status === 'Partial') ||
                      applicantForm.completion_status === 'Completed'
                    "
                    class="error--text"
                    >*</span
                  >
                </label>
              </v-col>

              <v-col cols="12" md="9" class="input-col">
                <v-text-field
                  v-if="edu.is_attached_certificate"
                  :value="edu.upload_certificate?.file_name"
                  hint="Document attached"
                  persistent-hint
                  dense
                  readonly
                  outlined
                  @click="$refs[`certificateInput_${index}`][0].click()"
                  prepend-inner-icon="mdi-file-upload"
                ></v-text-field>

                <v-file-input
                  v-else
                  v-model="edu.upload_certificate"
                  outlined
                  :value="edu.upload_certificate?.file_name"
                  :rules="
                    index !== educationForm.length - 1 ||
                    (edu.qualification_order > 2 &&
                      applicantForm.completion_status === 'Partial') ||
                    applicantForm.completion_status === 'Completed'
                      ? [rules.required]
                      : []
                  "
                  dense
                  accept="application/pdf, image/png, image/jpeg, image/jpg"
                  hide-details="auto"
                  prepend-inner-icon="mdi-file-upload"
                  prepend-icon=""
                ></v-file-input>
                <input
                  type="file"
                  style="display: none"
                  :ref="'certificateInput_' + index"
                  @change="onCertificateChanged($event, index)"
                  accept="application/pdf, image/png, image/jpeg, image/jpg"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Kovida Expansion Panel -->
        <v-expansion-panel v-if="hasKovida" key="kovida-panel">
          <v-expansion-panel-header class="text-h6">
            Kovida
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="3" md="3" class="pt-6">
                <label class="form-label-status"
                  >Upload Certificate <span class="error--text">* </span></label
                >
              </v-col>
              <v-col cols="9" md="9">
                <v-text-field
                  v-if="applicantForm.is_kovida_certificate_attached"
                  v-model="applicantForm.kovida_certificate.file_name"
                  class=""
                  hint="Certificate Attached"
                  persistent-hint
                  dense
                  readonly
                  outlined
                  @click="$refs.kovidaCertificateInput.click()"
                  prepend-inner-icon="mdi-file-upload"
                ></v-text-field>
                <v-file-input
                  v-else
                  v-model="applicantForm.kovidaCertificate"
                  outlined
                  dense
                  accept="application/pdf, image/png, image/jpeg, image/jpg"
                  hide-details="auto"
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-file-upload"
                  prepend-icon=""
                ></v-file-input>
                <input
                  type="file"
                  style="display: none"
                  ref="kovidaCertificateInput"
                  @change="
                    onEmployeeFileChanged(
                      $event,
                      'kovidaCertificate',
                      'is_kovida_certificate_attached',
                    )
                  "
                  accept="application/pdf, image/png, image/jpeg, image/jpg"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- Submit and Reset Buttons -->
      <v-row v-if="!isReadOnly" class="form-row mt-6">
        <v-col cols="12" class="d-flex justify-end pr-0">
          <v-btn color="error" class="mr-4" @click="confirmReset">
            Reset
          </v-btn>
          <v-btn
            :disabled="
              (JSON.stringify(this.originalEducationForm) ==
                JSON.stringify(this.educationForm) &&
                JSON.stringify(this.applicantForm) ==
                  JSON.stringify(this.copyApplicantForm)) ||
              submitLoading
            "
            :loading="submitLoading"
            color="success"
            class="mr-3"
            @click="submit"
          >
            Save & Next
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="confirmationDialog" width="450" persistent>
      <confirmationDialogForm
        v-if="confirmationDialog"
        :confirmationText="confirmationText"
        @closeDialog="confirmationDialog = false"
        @saveDialog="reset"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { rules } from "@/helpers/rules";
import ProfileUpload from "./ProfileUpload.vue";
import ImageUpload from "./ImageUpload.vue";
import { cloneDeep } from "lodash";
import confirmationDialogForm from "../components/confirmationDialog.vue";
// import { educationPayload } from "@/helpers/payload";

export default {
  components: { ProfileUpload, ImageUpload, confirmationDialogForm },
  data: () => ({
    rules,
    menu: false,
    valid: false,
    panels: [0],
    form: [],
    educationForm: [],
    kovidaData: null,
    applicantForm: {},
    copyApplicantForm: {},
    confirmationDialog: false,
    confirmationText: "",
    originalFormValue: [],
    originalEducationForm: [],
  }),
  props: {
    value: {
      type: Array,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    allForm: {
      type: Object,
      required: true,
    },
    submitLoading: { type: Boolean, default: false },
  },
  watch: {
    valid(newValue) {
      if (!newValue) return this.$emit("validate", false);
      this.$emit(
        "validate",
        JSON.stringify(this.originalFormValue) === JSON.stringify(this.form) &&
          JSON.stringify(this.applicantForm) ===
            JSON.stringify(this.copyApplicantForm),
      );

      const lastPanel = Math.max(...this.panels);
      const prev = this.educationForm[lastPanel];

      let isFilled =
        prev?.name_of_institution &&
        (prev?.qualification_order > 2
          ? prev?.upload_certificate && prev?.upload_image
          : prev?.upload_image);

      const nextPanel = lastPanel + 1;

      if (
        isFilled &&
        nextPanel < this.educationForm.length &&
        !this.panels.includes(nextPanel)
      ) {
        this.panels.push(nextPanel);
      }
    },
    educationForm: {
      handler(newVal) {
        if (
          !this.valid ||
          JSON.stringify(this.originalEducationForm) !== JSON.stringify(newVal)
        ) {
          this.$emit("validate", false);
        } else {
          this.$emit("validate", true);
        }
      },
      deep: true,
    },
    value: {
      handler(newVal) {
        this.form = cloneDeep(newVal);
        this.separateKovidaFromForm();
        this.formApplicantForm();
        // this.originalFormValue = cloneDeep(this.form);
      },
      deep: true,
    },
    form: {
      handler(newVal) {
        if (
          !this.valid ||
          JSON.stringify(this.originalFormValue) !== JSON.stringify(newVal)
        ) {
          this.$emit("validate", false);
        } else {
          this.$emit("validate", true);
        }
      },
      deep: true,
    },
    applicantForm: {
      handler(newVal) {
        if (
          !this.valid ||
          JSON.stringify(this.copyApplicantForm) !== JSON.stringify(newVal)
        ) {
          this.$emit("validate", false);
        } else {
          this.$emit("validate", true);
        }
      },
      deep: true,
    },
  },
  computed: {
    hasKovida() {
      return this.kovidaData !== null;
    },
    isAllEducationComplete() {
      // Check if all education panels are completed
      return this.educationForm.every((edu) => {
        return (
          edu.name_of_institution &&
          (edu.qualification_order > 2
            ? edu.upload_certificate && edu.upload_image
            : edu.upload_image)
        );
      });
    },
    isPreviousLevelComplete() {
      return (index) => {
        if (index === 0) return true;
        const previous = this.educationForm[index - 1];

        return (
          previous.name_of_institution &&
          (index > 2
            ? previous.upload_certificate && previous.upload_image
            : previous.upload_image)
        );
      };
    },
  },
  created() {
    this.form = cloneDeep(this.value);
    this.separateKovidaFromForm();
    this.formApplicantForm();
    this.originalFormValue = cloneDeep(this.form);
    this.$nextTick(() => {
      this.educationForm.map((item, index) => {
        if (item.name_of_institution) {
          this.panels.push(index);
          this.$forceUpdate();
        }
      });
    });
  },
  methods: {
    separateKovidaFromForm() {
      this.originalEducationForm = cloneDeep(this.educationForm);
      const kovidaIndex = this.form.findIndex(
        (item) => item.qualification_name === "Kovida",
      );

      if (kovidaIndex !== -1) {
        this.kovidaData = this.form[kovidaIndex];
        this.educationForm = this.form.filter(
          (item) => item.qualification_name !== "Kovida",
        );
        if (this.kovidaData.upload_image && this.kovidaData.upload_image.id) {
          this.applicantForm.is_kovida_certificate_attached = true;
          this.applicantForm.kovida_certificate = this.kovidaData.upload_image;
        }
      } else {
        this.educationForm = cloneDeep(this.form);
        this.kovidaData = null;
      }
      this.$forceUpdate();
    },
    onFileChanged(event, index) {
      const file = event.target.files[0];
      if (file) {
        this.$set(this.educationForm, index, {
          ...this.educationForm[index],
          upload_image: file,
          is_attached: false,
        });
      }
    },
    onCertificateChanged(event, index) {
      const file = event.target.files[0];
      if (file) {
        this.$set(this.educationForm, index, {
          ...this.educationForm[index],
          upload_certificate: file,
          is_attached_certificate: false,
        });
      }
    },
    getPlaceholder(type) {
      return type === "marks"
        ? "Enter Marks"
        : type === "grade"
        ? "Enter Grade"
        : "Enter CGPA";
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      // Merge educationForm and Kovida data back for submission
      const finalForm = [...this.educationForm];
      if (this.hasKovida) {
        const kovidaEntry = {
          ...this.kovidaData,
          upload_image:
            this.applicantForm.kovidaCertificate ||
            this.applicantForm.kovida_certificate,
          name_of_institution: "Kovida",
          qualification_name: "Kovida",
        };
        finalForm.push(kovidaEntry);
      }
      this.$emit("submit", finalForm, this.applicantForm);
    },
    confirmReset() {
      this.confirmationText =
        "This will clear the data you have entered in this page. Are you sure you want to reset ?";
      this.confirmationDialog = true;
    },
    reset() {
      this.educationForm = this.educationForm.map((item) => {
        return {
          ...item,
          upload_image: null,
          is_attached: false,
          upload_certificate: null,
          is_attached_certificate: false,
          name_of_institution: null,
        };
      });
      this.panels = [0];
      this.confirmationDialog = false;
      this.originalEducationForm = cloneDeep(this.educationForm);
      this.$refs.form.resetValidation();
    },
    validatePair(index) {
      this.$nextTick(() => {
        const marksRef = this.$refs["marks_"]?.[index];
        const totalRef = this.$refs["total_"]?.[index];

        if (marksRef && marksRef.validate) marksRef.validate();
        if (totalRef && totalRef.validate) totalRef.validate();
      });
    },
    onEmployeeFileChanged(file, value, boolean) {
      this.applicantForm[value] = file.target.files[0];
      this.applicantForm[boolean] = false;
    },
    formApplicantForm() {
      const {
        completion_status,
        occupation,
        company_name,
        employee_id,
        id_card,
        employment_letter,
        is_employment_letter_attached,
        is_id_card_attached,
        employee_email_id,
        kovida_certificate,
        is_kovida_certificate_attached,
      } = this.allForm;

      this.applicantForm = {
        completion_status,
        occupation,
        company_name,
        employee_id,
        id_card,
        employment_letter,
        is_employment_letter_attached,
        is_id_card_attached,
        employee_email_id,
        kovida_certificate: kovida_certificate || { file_name: null },
        is_kovida_certificate_attached: is_kovida_certificate_attached || false,
        kovidaCertificate: null,
        completion_status: completion_status || "Completed",
      };
      this.copyApplicantForm = JSON.parse(JSON.stringify(this.applicantForm));
    },
  },
};
</script>

<style scoped>
.input-col {
  padding-top: 0;
}

.form-label {
  font-weight: 600;
}

.form-label-status {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
}
.disabled-label {
  color: #bdbdbd;
}
::v-deep(.v-messages) {
  color: green !important;
}
</style>
